import Palpaciones from "./Palpaciones";
export default Palpaciones;